/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
const configurations = new Map([
  [
    '#F69708',
    [
      'Vacantes activas',
      'Gestionados',
      'Invitaciones',
      'Referentes',
      'Test finalizados',
      'Videoentrevistas',
      'Administradores',
      'Postulantes activos',
      'A modificar'
    ]
  ],
  [
    '#24BB72',
    [
      'Vacantes creadas',

      'Asistencias',
      'Referidos',
      'Test asignados',
      // esto va a dar error, Hay Dos postulantes con dos colores diferentes
      'Postulantes',
      'Reclutadores',
      'Contratados',
      'Aprobadas'
    ]
  ],
  [
    '#3B3F51',
    [
      'Vacantes cubiertas',
      'Entrevistados',
      'Test reasignados',
      'Postulantes finalizados',
      'Consultores externos',
      'Visitas',
      'Pendientes'
    ]
  ],
  ['#ED6B75', ['Vacantes canceladas', 'En etapa entrevista', 'Inasistencias', 'Rechazados', 'Rechazadas']],
  ['#3598DC', ['Días de gestión', 'Postulaciones', 'Postulantes pendientes', 'Solicitudes']]
]);

const configurationsTwo = new Map([
  ['hr-Arrow-right', ['Test asignados']],
  ['hr-Interview', ['Entrevistados']],
  ['hr-Recruiter', ['Reclutadores']],
  ['hr-External', ['Consultores externos']],
  ['hr-Solicit', ['Solicitudes']],
  ['hr-Request', ['En etapa entrevista']],
  ['hr-CV', ['Postulaciones']],
  ['hr-Change', ['Test reasignados']],
  ['hr-Trophy', ['Contratados']],
  ['hr-Magnet', ['Referidos']],
  ['hr-Video', ['Videoentrevistas']],
  ['hr-Admin', ['Administradores']],
  ['hr-Close', ['Inasistencias', 'Rechazados', 'Rechazadas']],
  ['hr-Lock', ['Vacantes cubiertas']],
  ['hr-Team', ['Referentes']],
  ['hr-Person', ['Gestionados', 'Postulantes activos']],
  ['hr-Calendar', ['Días de gestión', 'Invitaciones']],
  ['hr-Checkmark', ['Vacantes activas', 'Postulantes finalizados', 'Asistencias', 'Test finalizados', 'Aprobadas']],
  ['hr-Plus', ['Vacantes creadas']],
  ['hr-Clock', ['Vacantes canceladas', 'Pendientes', 'Postulantes pendientes']],
  ['hr-Eye-open', ['Visitas']],
  ['hr-Pencil', ['A modificar']]
]);

export const getColor = (find) => {
  for (const [key, value] of configurations.entries()) {
    if (value.indexOf(find) !== -1) return key;
  }
};

export const getIcon = (find) => {
  for (const [key, value] of configurationsTwo.entries()) {
    if (value.indexOf(find) !== -1) return key;
  }
};
